<template>
  <v-container>
    <h4 class="earth-color">ADD BENEFICIARY</h4>
    <v-form>
      <v-layout row wrap>
        <v-flex lg4 md4 sm12 xs12><v-container>
          <v-select
            label="Title"
            v-model="beneficiary.ltitle"
            :items="['Mr.', 'Mrs.', 'Ms.', 'Dr.', 'Eng.', 'Prof.']"
            :rules="[v => !!v || 'Title method is required']"
            required
            :loading="$loadingTrue"
          ></v-select>
        </v-container></v-flex>
        <v-flex lg4 md4  sm12 xs12><v-container>
          <v-text-field
            v-model="beneficiary.lfirst_name"
            :rules="requiredRules"
            label="First Name"
            maxlength="20"
            required
          ></v-text-field>
        </v-container></v-flex>
        <v-flex lg4 md4  sm12 xs12><v-container>
          <v-text-field
            v-model="beneficiary.lsur_name"
            :rules="requiredRules"
            label="Last Name"
            maxlength="20"
            required
          ></v-text-field>
        </v-container></v-flex>
        <v-flex lg4 md4  sm12 xs12><v-container>
          <v-select
            label="Gender"
            v-model="beneficiary.lgender_id"
            :items="allGender"
            :rules="[v => !!v || 'Gender is required']"
            item-text="name"
            item-value="public_id"
            required
            :loading="$loadingTrue"
          ></v-select>
        </v-container></v-flex>
        <v-flex lg4 md4 sm12 xs12><v-container>
          <v-dialog
            ref="dialog"
            persistent
            v-model="modal1"
            lazy
            full-width
            width="290px"
            :return-value.sync="beneficiary.ldob"
          >
            <v-text-field
              slot="activator"
              label="Date of Birth"
              v-model="beneficiary.ldob"
              :rules="requiredRules"
              readonly
            ></v-text-field>
            <v-date-picker
              v-model="beneficiary.ldob"
              :max="start_date"
              scrollable>
              <v-spacer></v-spacer>
              <v-btn :depressed="true" flat color="primary" @click="modal1 = false">Cancel</v-btn>
              <v-btn :depressed="true" flat color="primary" @click="$refs.dialog.save(beneficiary.ldob)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-container></v-flex>
        <v-flex lg4 md4  sm12 xs12><v-container>
          <v-text-field
            v-model="beneficiary.lid_alien_number"
            label="ID Number/Alien ID"
            hint="Required for every visit *"
            maxlength="30"
          ></v-text-field>
        </v-container></v-flex>
        <v-flex lg6 md6  sm12 xs12><v-container>
          <v-text-field
            v-model="beneficiary.lemail"
            label="Email"
            required
            type="email"
          ></v-text-field>
        </v-container></v-flex>
        <v-flex lg6 md6 sm12 xs12><v-container>
          <v-text-field
            v-model="beneficiary.lphone_number"
            label="Phone Number (e.g. +XXX...)"
            minlength="13"
            type="number"
          ></v-text-field>
        </v-container></v-flex>
      </v-layout>
      <v-btn :depressed="true" color="primary" @click="addBeneficiary()">Add Beneficiary</v-btn>
    </v-form>
  </v-container>
</template>

<script>
import VueNotifications from 'vue-notifications'
export default {
  props: ['residence', 'email'],
  name: 'AddBeneficiary',
  data () {
    return {
      start_date: this.$moment().format('YYYY-MM-DD'),
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      valid: true,
      menu1: false,
      modal1: false,
      dob_config2: {
        maxDate: 'today'
      },
      beneficiary: {
        ltitle: '',
        lfirst_name: '',
        lsur_name: '',
        lgender_id: '',
        ldob: '',
        lid_alien_number: '',
        lemail: '',
        lpostal_address: '',
        lpostal_code: '',
        lphone_number: ''
      }
    }
  },
  created () {
    console.log(this.allBeneficiaries)
  },
  methods: {
    resetInputs () {
      this.beneficiary = {
        ltitle: '',
        lfirst_name: '',
        lsur_name: '',
        lgender_id: '',
        ldob: '',
        lid_alien_number: '',
        lemail: '',
        lpostal_address: '',
        lpostal_code: '',
        lphone_number: ''
      }
    },
    addBeneficiary: function () {
      var validation = true
      var hasAdult = false
      var moment = this.$moment
      var data = {
        title: this.beneficiary.ltitle,
        first_name: this.beneficiary.lfirst_name,
        sur_name: this.beneficiary.lsur_name,
        gender_id: this.beneficiary.lgender_id,
        dob: this.$moment(this.beneficiary.ldob).format('YYYY-MM-DD'),
        id_alien_number: this.beneficiary.lid_alien_number,
        email: this.beneficiary.lemail,
        postal_address: this.beneficiary.lpostal_address,
        postal_code: this.beneficiary.lpostal_code,
        phone_number: this.beneficiary.lphone_number,
        amount: 0
      }
      // Couple
      if (this.residence.household_id === 'bj4483n2' && this.allBeneficiaries.length === 0) {
        this.$store.commit('ADD_BENEFICIARY', data)
        this.resetInputs()
        validation = false
        return
      } else if (this.residence.household_id === 'bj4483n2' && this.allBeneficiaries.length > 0) {
        VueNotifications.error({ message: 'Maximum number for a couple is ' + this.residence.number_of_persons })
        validation = false
        return
      }
      if (data.dob === 'Invalid date') {
        VueNotifications.error({ message: 'Date of birth cannot be null' })
        validation = false
        return
      }
      // if (data.email === this.email) {
      //   VueNotifications.error({ message: 'Beneficiary emails cannot be the same as the Principal\'s email.' })
      //   validation = false
      //   return
      // }
      // Beneficiary is above 18 years
      var dif2 = moment().diff(moment(data.dob), 'years')
      if (dif2 >= 18) {
        if (data.email === '') {
          validation = false
          VueNotifications.error({ message: 'Beneficiary is 18 is and above. Email is required.' })
        }
        if (data.phone_number === '') {
          validation = false
          VueNotifications.error({ message: 'Beneficiary is 18 is and above. Phone number is required.' })
        }
      }
      this.allBeneficiaries.map(function (beneficiary) {
        var dif = moment().diff(moment(beneficiary.dob), 'years')
        if (dif2 >= 18 && dif >= 18) {
          validation = false
          hasAdult = true
          VueNotifications.error({ message: 'You can\'t have more than 2 beneficiaries who are above 18 years of age.' })
        }
        // if (beneficiary.email === data.email) {
        //   validation = false
        //   VueNotifications.error({ message: 'Beneficiary Emails cannot be the same.' })
        // }
        // if (beneficiary.phone_number === data.phone_number) {
        //   validation = false
        //   VueNotifications.error({ message: 'Beneficiary Phone numbers cannot be the same' })
        // }
        // if (beneficiary.id_alien_number === data.id_alien_number) {
        //   validation = false
        //   VueNotifications.error({ message: 'Beneficiary Identification cannot be the same cannot be the same' })
        // }
      })
      // Family
      if (validation === true && hasAdult === false) {
        // Family
        if (this.allBeneficiaries.length < Number(this.membershipRegistrationTotal) - 1) {
          this.$store.commit('ADD_BENEFICIARY', data)
         
          this.resetInputs()
        } else {
          if (this.residence.resident_id === 'njdnjf') {
            // KES
            data.amount = 2400
          } else {
            // KES
            data.amount = 4800
          }
          this.$store.commit('ADD_BENEFICIARY', data)
          this.resetInputs()
        }
      }
    }
  }
}
</script>

<style scoped>
  .spacing {
    margin-left: 6%;
  }
</style>
